var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [(_vm.hub) ? _c('legend', [_vm._v("Combo Hub = " + _vm._s(_vm.hub))]) : _vm._e(), _vm._v(" "), _c('b-card', [(_vm.comboHubDetails.length === 0) ? _c('fieldset', [_vm._v("\n            No Combo Hub Found\n          ")]) : _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select Hub"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.hublist,
      "selected-option": _vm.hubitem,
      "id": "Hub",
      "name": "Hub",
      "placeholder": "Select Hub"
    },
    on: {
      "select": _vm.selectedHub
    },
    model: {
      value: (_vm.hub),
      callback: function($$v) {
        _vm.hub = $$v
      },
      expression: "hub"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.hubError))])], 1)])])]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hub),
      expression: "hub"
    }],
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagintype),
      expression: "bagintype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "BagIn Type",
      "id": "bagintype"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bagintype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.bagTypeChange($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Bag Scan Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ParentBagIn"
    }
  }, [_vm._v("Bag InScan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RTOBagIn"
    }
  }, [_vm._v("Bag OutScan")])])])], 1)], 1), _vm._v(" "), (_vm.showRTOBagIn) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('b-button', {
    staticClass: "common-secondary-btn",
    attrs: {
      "type": "submit",
      "disabled": _vm.flagLoadBatch == true
    },
    on: {
      "click": _vm.loadOrCreateBatch
    }
  }, [_vm._v("Load/Create Batch")])], 1) : _vm._e(), _vm._v(" "), (_vm.tableOfBatchDetails) ? _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Batch Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("No. Of Bags")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.batchDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.noofbags))])])
  }), _vm._v(" "), ((_vm.batchDetails && _vm.batchDetails.length == 0) || _vm.batchDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.BagOutShow) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('br'), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-briefcase'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagno),
      expression: "bagno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('BagNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Please Enter Bag No",
      "name": "BagNo",
      "id": "bagno"
    },
    domProps: {
      "value": (_vm.bagno)
    },
    on: {
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('BagNo')),
      expression: "errors.has('BagNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Bag No")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.BagOutShow) ? _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "1px"
    }
  }, [_c('br'), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "common-success-btn",
    attrs: {
      "type": "submit",
      "disabled": _vm.flagOutscan == true
    },
    on: {
      "click": _vm.bagOutScan
    }
  }, [_vm._v("Out Scan")]), _vm._v("  \n                          "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.BagOutShow) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Total bags in batch :" + _vm._s(_vm.batchbagcount))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.BagOutShow) ? _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Batch Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.outScanBagDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))])])
  }), _vm._v(" "), ((_vm.outScanBagDetails && _vm.outScanBagDetails.length == 0) || _vm.outScanBagDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), (_vm.batchbagcount > 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "common-success-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeBatch
    }
  }, [_vm._v("Close Batch")]), _vm._v("  \n                          "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm1
    }
  }, [_vm._v("Reset")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br')]), _vm._v(" "), (_vm.showParentBagIn) ? _c('div', {
    staticClass: "col-md-6 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inscantype),
      expression: "inscantype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "inscantype",
      "value": "baginscan"
    },
    domProps: {
      "checked": _vm._q(_vm.inscantype, "baginscan")
    },
    on: {
      "change": function($event) {
        _vm.inscantype = "baginscan"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "baginscan"
    }
  }, [_c('h5', [_vm._v("Bag Inscan")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.showParentBagIn) ? _c('div', {
    staticClass: "col-md-6 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inscantype),
      expression: "inscantype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "inscantype",
      "value": "batchinscan"
    },
    domProps: {
      "checked": _vm._q(_vm.inscantype, "batchinscan")
    },
    on: {
      "change": function($event) {
        _vm.inscantype = "batchinscan"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "batchinscan"
    }
  }, [_c('h5', [_vm._v("Batch Inscan")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('inscantype')),
      expression: "errors.has('inscantype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Any One Option")]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), (_vm.showParentBagIn) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-briefcase'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inscanbagorbatch),
      expression: "inscanbagorbatch"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('inscanbagorbatch')
    },
    attrs: {
      "type": "text",
      "placeholder": "Please Inscan Bag and Batch",
      "name": "inscanbagorbatch",
      "id": "inscanbagorbatch"
    },
    domProps: {
      "value": (_vm.inscanbagorbatch)
    },
    on: {
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inscanbagorbatch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('inscanbagorbatch')),
      expression: "errors.has('inscanbagorbatch')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Valid Bag or Batch")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showParentBagIn) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.flagInscan == true
    },
    on: {
      "click": _vm.BagInscan
    }
  }, [_vm._v("InScan")]), _vm._v("  \n                          "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])], 1)], 1) : _vm._e()])])], 1), _vm._v(" "), (_vm.showResulstHubSection) ? [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-tabs', {
    staticStyle: {
      "border": "1px solid #cecece"
    },
    attrs: {
      "content-class": "mt-3"
    }
  }, [_c('br'), _vm._v(" "), (_vm.showServiceType != 'pb') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticStyle: {
      "color": "SlateBlue",
      "margin-left": "10%"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("Total Bags to "), (_vm.showServiceType == 'il') ? _c('span', [_vm._v("Receive:" + _vm._s(_vm.inScanCount))]) : _vm._e(), (_vm.showServiceType == 'ol') ? _c('span', [_vm._v("Handover:" + _vm._s(_vm.outScanCount))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 radio"
  }, [_c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servicetype),
      expression: "servicetype"
    }],
    attrs: {
      "type": "radio",
      "id": "ecom",
      "name": "servicetype",
      "value": "Ecom",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.servicetype, "Ecom")
    },
    on: {
      "change": [function($event) {
        _vm.servicetype = "Ecom"
      }, function($event) {
        return _vm.onChange($event)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ecom"
    }
  }, [_vm._v("ECOM")]), _c('br')])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servicetype),
      expression: "servicetype"
    }],
    attrs: {
      "type": "radio",
      "id": "cargo",
      "name": "servicetype",
      "value": "Cargo"
    },
    domProps: {
      "checked": _vm._q(_vm.servicetype, "Cargo")
    },
    on: {
      "change": [function($event) {
        _vm.servicetype = "Cargo"
      }, function($event) {
        return _vm.onChange($event)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cargo"
    }
  }, [_vm._v("CARGO")]), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.showServiceType == 'pb') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticStyle: {
      "color": "SlateBlue",
      "margin-left": "5%"
    }
  }, [_vm._v("Total Pending Batch:" + _vm._s(_vm.pendingBatchCount))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "cursor": "pointer",
      "float": "right",
      "margin-right": "5%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getAllPendingBatch
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])]) : _vm._e(), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Bags To InScan",
      "selected": true
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [
    [_c('table', {
      staticClass: "b-table table table-bordered"
    }, [_c('thead', {
      staticClass: "thead-default"
    }, [_c('tr', {
      staticClass: "text-primary"
    }, [_c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("#")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Bag Type ")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Bag Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.allBagsToInScan), function(data, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.bagstatus))])])
    }), _vm._v(" "), ((_vm.allBagsToInScan && _vm.allBagsToInScan.length == 0) || _vm.allBagsToInScan.length == 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "8"
      }
    }, [_vm._v("No Data Found")])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.inScanCount != 0) ? _c('paginate', {
      attrs: {
        "page-count": _vm.pageCountForInScan,
        "page-range": 2,
        "margin-pages": 2,
        "click-handler": _vm.getPaginationDataForInScanBags,
        "prev-text": 'Prev',
        "next-text": 'Next',
        "container-class": 'pagination'
      }
    }) : _vm._e()]
  ], 2)])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Bags To OutScan"
    },
    on: {
      "click": function($event) {
        return _vm.getAllBagsToOutScan()
      }
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [
    [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('thead', {
      staticClass: "thead-default"
    }, [_c('tr', {
      staticClass: "text-primary"
    }, [_c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("#")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Bag Type ")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Bag Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.allBagsToInOutScan), function(data, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.bagstatus))])])
    }), _vm._v(" "), ((_vm.allBagsToInOutScan && _vm.allBagsToInOutScan.length == 0) || _vm.allBagsToInOutScan.length == 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "8"
      }
    }, [_vm._v("No Data Found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.outScanCount != 0) ? _c('paginate', {
      attrs: {
        "page-count": _vm.pageCount,
        "page-range": 2,
        "margin-pages": 2,
        "click-handler": _vm.getPaginationDataForOutScanBags,
        "prev-text": 'Prev',
        "next-text": 'Next',
        "container-class": 'pagination'
      }
    }) : _vm._e()]
  ], 2)])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Pending Batch"
    },
    on: {
      "click": function($event) {
        return _vm.getAllPendingBatch()
      }
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.comboHubBatch.length !== 0) ? [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Batch Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("No Of Bags")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pending In Scan")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.comboHubBatch), function(data, index) {
    return (_vm.comboHubBatch.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.noofbags))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.ShowPendingBags(data.combohubbatchid)
        }
      }
    }, [_vm._v(_vm._s(data.pendinginscan))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.ShowPendingAWB(data.combohubbatchid)
        }
      }
    }, [_vm._v(_vm._s(data.awbcount))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))])]) : _vm._e()
  }), _vm._v(" "), (_vm.comboHubBatch.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.pendingBatchCount != 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pageCountForBatch,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationDataForPendingBatch,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination'
    }
  }) : _vm._e()] : _vm._e()], 2)])])], 1)], 1)])])] : _vm._e(), _vm._v(" "), _c('b-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    attrs: {
      "size": "lg",
      "title": "Pending Bags In Batch"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Pending Bags In Batch")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticStyle: {
      "color": "purple"
    }
  }, [_vm._v("Total Pending bags to Inscan :"), _c('b', [_vm._v(_vm._s(_vm.pendingBagCount))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("BagNo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("BagType")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("BagStatus")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.pendingBags), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))])])
  }), _vm._v(" "), ((_vm.pendingBags && _vm.pendingBags.length == 0) || _vm.pendingBags.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.pendingBagCount != 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pageCountForPendingBags,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationDataForPendingBags,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('b-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModalForAWB),
      expression: "showModalForAWB"
    }],
    attrs: {
      "size": "lg",
      "title": "AWB Outscan List against Batch"
    },
    model: {
      value: (_vm.showModalForAWB),
      callback: function($$v) {
        _vm.showModalForAWB = $$v
      },
      expression: "showModalForAWB"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("AWB Outscan List against Batch")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.pendingBags), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))])])
  }), _vm._v(" "), ((_vm.pendingBags && _vm.pendingBags.length == 0) || _vm.pendingBags.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])])])], 2)])], 1)], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37b7f2f8","hasScoped":true}!./src/views/components/combohub/combohub.html
// module id = 1201
// module chunks = 2